export const SET_HEADER_NAME = 'SET_HEADER_NAME';
export const SET_OPEN_MENU = 'SET_OPEN_MENU';
